import { ListItemText, Autocomplete, TextField, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomDateSpectrum } from "../../api/customObjectsTypes";
import { generalGet } from "../../api/general";

export const DateSpectrumLabel = ({
    label,
    value,
    onValueChange,
    disabled,
    placeholder,
    setSelectedValue,
}: {
    label?: string | undefined,
    value?: string,
    onValueChange?: (event: string | null) => void,
    disabled?: boolean,
    placeholder?: string,
    setSelectedValue?: (value: CustomDateSpectrum | null) => void,
}) => {
    const [optionsState, setOptionsState] = useState<CustomDateSpectrum[] | undefined>(undefined);

    useEffect(() => {
        const fetchData = async () => {
            const data = await generalGet<CustomDateSpectrum[]>('api/configuration/date-spectrums');
            setOptionsState(data.data as CustomDateSpectrum[]);
        };

        fetchData();
    }, []);

    return (
        <Grid container spacing={0} sx={{ mb: 2 }}>
            <Grid size={2}>
                <ListItemText primary={label} primaryTypographyProps={{ fontWeight: 600, fontSize: 14 }} />
            </Grid>
            <Grid size={10}>
                <Autocomplete
                    options={(optionsState || []).map((option) => option.dateSpectrum)}
                    getOptionLabel={(option) => option}
                    value={value || null}
                    onChange={(event, newValue) => {
                        const selectedOption = (optionsState || []).find(
                            (option) => option.dateSpectrum === newValue
                        );
                        if (setSelectedValue) {
                            setSelectedValue(selectedOption ? selectedOption : null);
                        }
                        if (onValueChange) {
                            onValueChange(newValue || null);
                        }
                    }}
                    onBlur={(event) => {
                        const inputValue = (event.target as HTMLInputElement).value;
                        const matchingOptions = (optionsState || []).filter(option =>
                            option.dateSpectrum.toLowerCase().includes(inputValue.toLowerCase())
                        );
                        if (matchingOptions.length === 1) {
                            const selectedOption = matchingOptions[0];
                            if (setSelectedValue) {
                                setSelectedValue(selectedOption);
                            }
                            onValueChange?.(selectedOption.dateSpectrum);
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholder || ""}
                            sx={{ width: "100%" }}
                            inputProps={{ ...params.inputProps, style: { fontSize: 14 } }}
                            InputLabelProps={{ style: { fontSize: 14 } }}
                            variant="standard"
                            disabled={disabled}
                        />
                    )}
                />
            </Grid>
        </Grid>
    )
}